import dynamic from 'next/dynamic';

import type { ContentTilesSectionProps } from '../../../components/sections/ContentTilesSection';
import type { SectionRenderer } from '../../../types/Section';
import type { Transformer } from '../../../types/Transformer';
import type { ContentTilesSectionContent } from './types';
import { validateNumberOfTiles } from './validation';

/* istanbul ignore next */
export const renderer: SectionRenderer<ContentTilesSectionProps> =
  dynamic<ContentTilesSectionProps>(() =>
    import('../../../components/sections/ContentTilesSection').then(
      (mod) => mod.ContentTilesSection,
    ),
  );

export const transformer: Transformer<ContentTilesSectionContent, ContentTilesSectionProps> = ({
  _metadata,
  items,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    tiles: items.map(({ title, url, image, tile_background_color }) => ({
      title,
      href: url,
      imageSrc: image.url,
      ...(tile_background_color.custom_background_color && {
        backgroundColor: tile_background_color.background_color,
      }),
    })),
    trackingTitle: tracking_title,
  },
  errors: validateNumberOfTiles(items.length),
});
